import "@/stylesheets/components/collapsible_sidebar.scss"

export class CollapsibleSidebar {
  element: HTMLElement;
  expandedSize: string;
  collapsed: boolean;
  timeoutId: any;

  constructor(element: HTMLElement) {
    this.element = element;
    const minSize = (element.children[0] as HTMLElement)?.offsetWidth;
    this.expandedSize = !minSize ? "500px" : minSize.toString();
    this.collapsed = element.classList.contains("d-none");
    if (this.collapsed) this.element.style.width = "0";
    this.timeoutId = null;

    document.querySelectorAll(`[data-bs-toggle="collapse-horizontal"][data-bs-target="${element.id}"]`).forEach(toggleButton => {
      (toggleButton as HTMLButtonElement).onclick = event => this.toggleHandler(event);
    });
  }

  toggleCollapse(force: boolean = null) {
    this.collapsed = force !== null ? force : !this.collapsed;
    if (this.collapsed) {
      this.element.style.width = "0";
      if (this.timeoutId) clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.element.classList.toggle("d-none", true);
      }, 350) // delay setting display = none, as it cannot be transitioned
    } else {
      this.element.classList.toggle("d-none", false);
      setTimeout(() => {
        this.element.style.width = this.expandedSize;
      }, 33); // if width is changed at the same time as display was none, the transition is skipped
    }
  }

  toggleHandler(event: Event) {
    this.toggleCollapse();
    (event.currentTarget as HTMLElement).classList.toggle("toggled", !this.collapsed);
    (event.currentTarget as HTMLElement).setAttribute("aria-expanded", this.collapsed ? "false" : "true");
    event.preventDefault();
  }
}
